<div class="d-flex flex-column">
  <form (ngSubmit)="onNameSearch(true)" [formGroup]="nameSearchForm">
    <div class="row">
      <div class="col-3">
        <span class="search-text">Member's First Name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Member First Name"
          formControlName="firstName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Member's Last Name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Member Last Name"
          formControlName="lastName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Guardian's First Name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Guardian First Name"
          formControlName="guardianFirstName"
        />
      </div>
      <div class="col-3">
        <span class="search-text">Guardian's Last Name</span>
        <input
          class="dp-input-control update-input mt-2"
          placeholder="Guardian Last Name"
          formControlName="guardianLastName"
        />
      </div>

      <div class="radio-buttons-container search-text ">
        <label class="inpLabel">
          <input
            type="radio"
            formControlName="selectedRadioButton"
            name="selectedRadioButton"
            value="EX"
          />
          Exact Search
        </label>
        <label class="inpLabel">
          <input
            type="radio"
            formControlName="selectedRadioButton"
            name="selectedRadioButton"
            value="SW"
          />
          Start With Search
        </label>
        <label class="inpLabel">
          <input
            type="radio"
            formControlName="selectedRadioButton"
            name="selectedRadioButton"
            value="CN"
          />
          Contains Search
        </label>
      </div>

    </div>

    <div class="d-flex align-items-center btn-margin">
      <button class="dp-secondary-btn clear-btn" type="reset" (click)="onclickClear()">
        Clear Entries
      </button>
      <button class="dp-primary-btn search-btn ms-3">Search</button>
    </div>
  </form>

  @if(isLoader){
    <table class="dp-table">
      <thead class="dp-table-header">
        <tr>
          <th>Sl.no</th>
          <th>Mem Status</th>
          <th>District</th>
          <th>Name</th>
          <th>Guardian</th>
          <th>Initiation Date</th>
          <th>Ritwik</th>
          <th>Pin</th>
          <th>Adress</th>
        </tr>
      </thead>
      <tbody class="dp-table-body">
        <tr *ngFor="let i of [].constructor(numberOfLoaders)">
          <td *ngFor="let j of [].constructor(9)">
            <dp-loader></dp-loader>
          </td>
        </tr>
      </tbody>
    </table>
  }
  @else if(responseData.length>0){
    <div class="dp-table-scroll table-container"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000"
      (scrolled)="onNameSearch(false)">
    <dp-table
      [dataTable]="responseData"
      [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"
      [columnConfs]="columnConfs"
      [isLoader]="isLoader"
      (cellClick)="onCellClick($event)"
    ></dp-table>
  </div>
  }@else {
    <div class="noData" *ngIf="noDataFound">
      <div class="placeholderTable"></div>
      <p>No data found!</p>
    </div>
  }

  
</div>
